import React from 'react';
import classNames from 'classnames';

import css from './ListingCardSkeleton.module.css';

/**
 * A grey, shimmering stand-in for a ListingCard while products load. It has the
 * card's shape — a square photo, then the brand, title and price lines — so
 * nothing jumps when the real cards arrive.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className] extra class for the root element
 * @returns {JSX.Element}
 */
const ListingCardSkeleton = props => {
  const { className } = props;
  return (
    <div className={classNames(css.root, className)} aria-hidden="true">
      <div className={css.image} />
      <div className={css.brand} />
      <div className={css.title} />
      <div className={css.titleShort} />
      <div className={css.price} />
    </div>
  );
};

/**
 * A number of skeleton cards, e.g. to fill a grid or a row.
 *
 * @param {Object} props
 * @param {number} [props.count=4] how many cards
 * @param {string} [props.className] extra class for each card
 * @returns {Array<JSX.Element>}
 */
export const ListingCardSkeletons = props => {
  const { count = 4, className } = props;
  return [...Array(count).keys()].map(i => <ListingCardSkeleton key={i} className={className} />);
};

export default ListingCardSkeleton;
